module.exports = __webpack_public_path__ + "img/choose-box-hen.971dc16d.png";